import type { OrgGatewayEndpoint, OrgGatewayResolver } from '../types/admin'

export async function resolveOrgGateway(
  organizationId: string,
  fetchImplementation: typeof fetch = fetch,
): Promise<OrgGatewayEndpoint> {
  const response = await fetchImplementation(
    `/api/v1/organization/${encodeURIComponent(organizationId)}/agent/gateway/ws-info`,
    { credentials: 'include' },
  )

  if (response.status === 404) return null
  if (!response.ok) throw new Error(`Gateway resolver failed with HTTP ${response.status}`)

  const data = await response.json() as { url?: string; token?: string; expiresAt?: string }
  if (!data.url) return null

  return {
    url: data.url,
    token: data.token,
    expiresAt: data.expiresAt ? Date.parse(data.expiresAt) : undefined,
  }
}

export const orgGatewayResolver: OrgGatewayResolver = resolveOrgGateway
